module.exports = __webpack_public_path__ + "media/images/pages/img_shopping_03-9df9b91f13a7b6bad4edc7640b596e7a.jpg";